import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/** Merges class names so a caller's utility always wins over a component's default. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
